var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { title: "请选择发货方式", visible: _vm.visible, width: "630px" },
      on: {
        "update:visible": function($event) {
          _vm.visible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "flex items-center flex-item1" }, [
        _c(
          "div",
          {
            staticClass: "pointer pad40-tb radius5 bg-f2 text-center item",
            on: {
              click: function($event) {
                return _vm.selected("0")
              }
            }
          },
          [
            _c("div", { staticClass: "f18" }, [_vm._v("整单发货")]),
            _c("div", { staticClass: "gray9 mar5-t" }, [
              _vm._v("按订单进行一次性发货")
            ])
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "pointer pad40-tb radius5 bg-f2 text-center mar30-l item",
            on: {
              click: function($event) {
                return _vm.selected("1")
              }
            }
          },
          [
            _c("div", { staticClass: "f18" }, [_vm._v("部分发货")]),
            _c("div", { staticClass: "gray9 mar5-t" }, [
              _vm._v("可选择部分商品多次发货")
            ])
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }